module.exports = __webpack_public_path__ + "static/media/upcoming-expenses.87e8338d.png";